import { Middleware, PayloadAction } from '@reduxjs/toolkit'

import { enterTrackEvent } from 'src/Helpers/TagManager'

import rootReducer from '../root-reducer'
import { RootState } from '../index'

type Reducer = ReturnType<typeof rootReducer>

type MetaType = {
  requestStatus: 'pending' | 'fulfilled' | 'rejected'
  arg?: unknown
}

type PayloadType = {
  code: number
  message: string
}

const tikTokSearchTrackActions = [
  'searchTikTokTrackAuth',
  'searchTikTokTrackNoAuth',
]

export const enterTrackMiddleware: Middleware<unknown, Reducer> =
  (store) => (next) => async (action: unknown) => {
    const typedAction = action as PayloadAction<PayloadType, string, MetaType>
    const { authentication } = store.getState() as RootState
    const { user } = authentication.user

    const userId = user?.id
    const campaignType = !userId ? 'first' : 'basic'

    const isTikTokSearchTrackAction = (actionType: string): boolean =>
      tikTokSearchTrackActions.some((searchTrackActions) =>
        actionType.includes(searchTrackActions),
      )

    if (
      typedAction.meta?.requestStatus === 'fulfilled' &&
      isTikTokSearchTrackAction(typedAction.type)
    ) {
      const enteredText =
        (typedAction.meta?.arg as { searchText?: string })?.searchText ||
        (typedAction.meta?.arg as { search?: string })?.search

      enterTrackEvent({ userId, campaignType, enteredText })
    }

    return next(action)
  }
